module.exports = "<div>\n    <div class=\"loader\"></div>\n    <div class=\"overlay\"></div>\n</div>\n"